<template>
  <GameField />
</template>

<script>
import GameField from './components/GameField.vue'

export default {
  name: 'App',
  components: {
    GameField
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;0,900;1,900&display=swap');

html, button, input, span {
  font-family: 'Lato', sans-serif;
}

#app {
  max-width: 100vw;
  height: 90vh;
  padding: 10vh 0 0 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: dimgray;
  background-image: radial-gradient(circle at 1px 1px, darkgray 1px, transparent 0);
  background-size: 10px 10px;
}
</style>
